import { useDispatch } from 'react-redux';
import { E_CardActions } from '../_store';
import { getStoredValue } from "../_helpers/storageHelper";

const useCheckQuarantineWords = () => {
    const dispatch = useDispatch();
    const storedloginDetails = getStoredValue("loginDetails");

    const checkQuarantineWords = (inputText, dataList) => {
        const lowerInput = inputText?.toLowerCase() || "";
        const restrictedWords = dataList?.filter(item => item?.ActiveStatus !== 'InActive');

        const foundWords = restrictedWords?.filter(item => {
            const keyword = item?.MessageKeyword?.toLowerCase();
            if (!keyword) return false;

            if (item?.KeyWordFilterType === 'Whole Word') {
                const regex = new RegExp(`\\b${keyword}\\b`, 'i'); // whole word
                return regex.test(inputText);
            } else {
                return lowerInput.includes(keyword); // partial
            }
        });

        const uniqueWords = [...new Set(foundWords.map(w => w.MessageKeyword.toLowerCase()))];
        return uniqueWords;
    };

    const LoadQuarantineWords = async (subject) => {
        const objData = {
            messageKeyword: subject,
            facilityID: storedloginDetails?.FacilityID,
            webUserSentAction: "",
            inmateSentAction: "",
            keyWordFilterType: "",
            activeStatus: 2,
            pageNo: 1,
            rowCountPerPage: 10,
            sortBy: ""
        }
        return await dispatch(E_CardActions.LoadKeywordPUList(objData)).then((x) => {
            if (x?.payload?.DataList?.length > 0) {
                let result = x?.payload?.DataList?.filter(item => item?.ActiveStatus == 'Active' && item?.WebUserSentAction == "Quarantine");
                const foundWords = checkQuarantineWords(subject, result);
                if (foundWords?.length > 0) {
                    const unique = [...new Set(foundWords)]
                    const highlightedWords = unique?.map(
                        word => `<span class="text-danger fw-bold ">${word}</span>`
                    ).join(`<span class="text-danger fw-bold">${","} </span>`);
                    return { isQuarantineWords: true, highlightedWords: highlightedWords }
                }
                else {
                    return { isQuarantineWords: false }
                }
            }
            else {
                return { isQuarantineWords: false }
            }

        });
    };

    return LoadQuarantineWords;
};


export default useCheckQuarantineWords;
